export default () => ({
    userProperties: {},
    tenantProperties: [],
    conversationProperties: [],
    agentList: {},
    scenarioList:{},
    selectedConversation: {},
    teams: {},
    teamsAndUsers: [],
    activeAgents: [],
    areYouAnExistingCustomer: '',
    personId:'',
    orders:[],
    customerProperties: {},
    scenarioPeopleProperties: [],
    scenarioConversationProperties: [],
    orderShipmentMap: {},
    loginScreenStore: {
        meta: {
            loaders: {
                'SEND_CODE_FOR_LOGIN': false,
                'VERIFY_CODE_FOR_LOGIN': false,
            },
            errors: {
                'SEND_CODE_FOR_LOGIN': '',
                'VERIFY_CODE_FOR_LOGIN': '',
            },
        },
        loginInitiator: '',
        codeSentFor: {
            userLoginId: '',
            userIdType:'email',
        }
    }
})
